import type { DashboardWidgetConfiguration } from './widget-definition';

export const financeBankAccountMovementWidget: DashboardWidgetConfiguration = {
  widgetId: "finance.bank-account-movement",
  name: "Bank account movements",
  description: "Posted Finance journal balances at a selected date, scoped by RQL permissions.",
  apps: [
    "finance",
  ],
  template: "finance-money",
  query: {
    kind: "component",
    owner: "finance-money",
  },
  inputs: {
    title: "Bank account movements",
    mode: "movement",
  },
  dummyData: {
    value: "Posted balances",
    rows: [],
  },
  limits: {
    minWidth: 6,
    maxWidth: 12,
    minHeight: 4,
    maxHeight: 12,
    defaultWidth: 12,
    defaultHeight: 6,
  },
};
